import { FC } from 'react'

import styled from 'styled-components'

import { colors, device } from 'src/Helpers/constants'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  gap: 10px;
  padding: 10px;
  width: 100%;

  @media ${device.tabletMax} {
    display: none;
  }
`

const ParametersContainer = styled.div`
  display: grid;
  grid-column-gap: 16px;
  grid-template-columns: 0.8fr 0.4fr 0.5fr 0.5fr 1fr;
  width: 100%;
`

const Parameter = styled.div`
  font-size: 12px;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: ${colors.thirdGray};
  font-weight: 600;
  justify-content: flex-start;
`

const NameWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  width: 100%;
`

const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
`

export const InboxDocumentsHeader: FC = () => {
  return (
    <Container>
      <ParametersContainer>
        <NameWrapper>
          <Parameter>Договор / Клиент</Parameter>
        </NameWrapper>
        <Parameter>Статус</Parameter>
        <Parameter>Дедлайн</Parameter>
        <Parameter>Начато</Parameter>
        <ButtonsWrapper>
          <Parameter></Parameter>
        </ButtonsWrapper>
      </ParametersContainer>
    </Container>
  )
}
